/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventBar_event$ref: FragmentReference;
declare export opaque type EventBar_event$fragmentType: EventBar_event$ref;
export type EventBar_event = {|
  +participantUser: ?boolean,
  +hostResultUrl: ?string,
  +beginsAt: ?any,
  +name: ?string,
  +sgId: ?number,
  +banner: ?string,
  +hostHomepageUrl: ?string,
  +hostHomepageName: ?string,
  +location: ?string,
  +voucherCampaigns: ?$ReadOnlyArray<?{|
    +id: string
  |}>,
  +products: ?$ReadOnlyArray<?{|
    +type: ?string
  |}>,
  +$refType: EventBar_event$ref,
|};
export type EventBar_event$data = EventBar_event;
export type EventBar_event$key = {
  +$data?: EventBar_event$data,
  +$fragmentRefs: EventBar_event$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "EventBar_event",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "participantUser",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hostResultUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "beginsAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "sgId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "banner",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hostHomepageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hostHomepageName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "voucherCampaigns",
      "storageKey": null,
      "args": null,
      "concreteType": "VoucherCampaign",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "products",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '513698545f2aa27822ce812738568956';

module.exports = node;
